import axios from 'axios';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import authApis from '../../APIs/auth';
import constants from '../../constants';
import { useRoot } from '../../context/RootProvider';
import { HOME_ROUTE } from '../../routes/routePaths';
import store from '../../store';
import { requestAPI } from '../../utils';

const deleteToken = () => {
  localStorage.removeItem(constants.LOCAL_STORAGE_KEY.accessKey);
  localStorage.removeItem(constants.LOCAL_STORAGE_KEY.refreshKey);
};
const deleteUser = () => {
  localStorage.removeItem(constants.LOCAL_STORAGE_KEY.user);
};

const Logout = () => {
  const { clearAuth } = useRoot();
  const handleLogout = async () => {
    try {
      await requestAPI(authApis.logOut());
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    handleLogout();
    deleteUser();
    deleteToken();
    clearAuth();
    delete axios.defaults.headers.common.Authorization;
    delete axios.defaults.headers.Authorization;
    store.store.dispatch(store.Actions.set('loginDetails', {}));
    store.store.dispatch(store.Actions.resetRedux());
  }, []);
  return <Navigate to={HOME_ROUTE} replace />;
};

export default Logout;
